// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AnvD","title":"styles_title__1dAcU"};